const colour_int_to_rgb = (colour_int) => {
    return [colour_int >> 16, (colour_int >> 8) & 0xFF, colour_int & 0xFF];

}
const ColorMap = {
    1: '#AEFFDA',
    2: '#98F89F',
    3: '#D7DBA1',
    4: '#8FC7C5',
    5: '#BCC097',
    6: '#C497F1',
    7: '#E999CF',
    8: '#B8B49D',
    9: '#E9EDA2',
    10: '#F9A8DB',
    11: '#8F80E5',
    12: '#9DF8C6',
    13: '#D181D1',
    14: '#C0A78C',
    15: '#CF9B98',
    16: '#C2CF8C',
    17: '#EE8988',
    18: '#80BEB1',
    19: '#EEF181',
    20: '#9EF8E3',
    21: '#EEAAC9',
    22: '#CAC88E',
    23: '#94F1B0',
    24: '#88D8CC',
    25: '#86FC82',
    26: '#F08CD2',
    27: '#9D8090',
    28: '#EFBECC',
    29: '#9B9A8D',
    30: '#A68BA5',
    31: '#88F2FA',
    32: '#B7FBE4',
    33: '#BBDFE2',
    34: '#E2FFE1',
    35: '#96D08F',
    36: '#958F95',
    37: '#B0DF8E',
    38: '#82AEAB',
    39: '#C7DA8D',
    40: '#C195F5',
    41: '#F4E6A1',
    42: '#C3CFD4',
    43: '#A99392',
    44: '#C9B58E',
    45: '#EAE6AA',
    46: '#D3ACCE',
    47: '#FFF6F4',
    48: '#F495AF',
    49: '#E9C9F7',
    50: '#BFE1B3'
}

function getTeamColor(teamID, hostTeamID, isBot) {
    if (teamID === hostTeamID) {
        return '#0000FF';
    }
    if (isBot) {
        return '#00FF00';
    }
    return ColorMap[(teamID % 50) + 1];
}
export default getTeamColor;
